function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0.0898438 5.066406 C 0.0898438 3.410156 0.0898438 1.753906 0.0898438 0.09375 C 6.746094 0.09375 13.402344 0.09375 20.089844 0.09375 C 20.089844 1.71875 20.089844 3.351562 20.046875 5.023438 C 19.523438 5.078125 19.042969 5.089844 18.519531 5.097656 C 12.527344 5.09375 6.574219 5.09375 0.617188 5.09375 C 0.441406 5.09375 0.265625 5.074219 0.0898438 5.066406 Z M 0.0898438 5.066406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.089844 15.109375 C 20.089844 16.769531 20.089844 18.425781 20.089844 20.085938 C 13.433594 20.085938 6.777344 20.085938 0.0898438 20.085938 C 0.0898438 18.457031 0.0898438 16.824219 0.113281 15.148438 C 0.152344 15.097656 0.167969 15.089844 0.226562 15.085938 C 2.53125 15.089844 4.796875 15.09375 7.0625 15.089844 C 11.375 15.089844 15.683594 15.085938 20.015625 15.09375 C 20.054688 15.105469 20.070312 15.109375 20.089844 15.109375 Z M 20.089844 15.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,20%,62.7451%)",
      fillOpacity: 1
    },
    d: "M 0.0898438 11.644531 C 0.0898438 10.605469 0.0898438 9.566406 0.128906 8.484375 C 6.8125 8.445312 13.449219 8.445312 20.089844 8.445312 C 20.089844 9.511719 20.089844 10.582031 20.046875 11.691406 C 19.679688 11.726562 19.347656 11.722656 19.011719 11.707031 C 18.980469 11.703125 18.957031 11.710938 18.894531 11.726562 C 12.714844 11.734375 6.578125 11.734375 0.441406 11.734375 C 0.351562 11.734375 0.265625 11.722656 0.164062 11.703125 C 0.136719 11.664062 0.117188 11.652344 0.0898438 11.644531 Z M 0.0898438 11.644531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,65.882355%,0%)",
      fillOpacity: 1
    },
    d: "M 19.992188 15.082031 C 15.683594 15.085938 11.375 15.089844 7.0625 15.089844 C 4.796875 15.09375 2.53125 15.089844 0.214844 15.070312 C 0.140625 15.035156 0.117188 15.027344 0.0898438 15.023438 C 0.0898438 13.984375 0.0898438 12.945312 0.128906 11.863281 C 6.8125 11.820312 13.449219 11.820312 20.089844 11.820312 C 20.089844 12.859375 20.089844 13.898438 20.070312 14.984375 C 20.023438 15.039062 20.003906 15.054688 19.992188 15.082031 Z M 19.992188 15.082031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(85.09804%,0%,7.058824%)",
      fillOpacity: 1
    },
    d: "M 0.0898438 8.355469 C 0.0898438 7.347656 0.0898438 6.335938 0.128906 5.285156 C 6.308594 5.242188 12.449219 5.242188 18.625 5.242188 C 19.140625 5.214844 19.613281 5.183594 20.089844 5.15625 C 20.089844 6.195312 20.089844 7.234375 20.046875 8.3125 C 13.367188 8.355469 6.726562 8.355469 0.0898438 8.355469 Z M 0.0898438 8.355469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(85.09804%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 18.585938 5.242188 C 12.449219 5.242188 6.308594 5.242188 0.128906 5.246094 C 0.0898438 5.203125 0.0898438 5.164062 0.0898438 5.097656 C 0.265625 5.074219 0.441406 5.09375 0.617188 5.09375 C 6.574219 5.09375 12.527344 5.09375 18.519531 5.121094 C 18.570312 5.179688 18.578125 5.210938 18.585938 5.242188 Z M 18.585938 5.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(70.588237%,6.27451%,22.745098%)",
      fillOpacity: 1
    },
    d: "M 0.0898438 8.378906 C 6.726562 8.355469 13.367188 8.355469 20.046875 8.355469 C 20.089844 8.355469 20.089844 8.398438 20.089844 8.421875 C 13.449219 8.445312 6.8125 8.445312 0.128906 8.445312 C 0.0898438 8.445312 0.0898438 8.398438 0.0898438 8.378906 Z M 0.0898438 8.378906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(76.078433%,55.686277%,25.098041%)",
      fillOpacity: 1
    },
    d: "M 20.089844 11.800781 C 13.449219 11.820312 6.8125 11.820312 0.128906 11.820312 C 0.0898438 11.820312 0.0898438 11.777344 0.109375 11.753906 C 0.132812 11.730469 0.175781 11.71875 0.175781 11.71875 C 0.265625 11.722656 0.351562 11.734375 0.441406 11.734375 C 6.578125 11.734375 12.714844 11.734375 18.914062 11.730469 C 18.976562 11.726562 19.019531 11.71875 19.019531 11.71875 C 19.347656 11.722656 19.679688 11.726562 20.046875 11.734375 C 20.089844 11.734375 20.089844 11.777344 20.089844 11.800781 Z M 20.089844 11.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.274511%,38.039216%,39.607844%)",
      fillOpacity: 1
    },
    d: "M 18.625 5.242188 C 18.578125 5.210938 18.570312 5.179688 18.558594 5.125 C 19.042969 5.089844 19.523438 5.078125 20.046875 5.066406 C 20.089844 5.066406 20.089844 5.109375 20.089844 5.132812 C 19.613281 5.183594 19.140625 5.214844 18.625 5.242188 Z M 18.625 5.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,16.470589%,64.705884%)",
      fillOpacity: 1
    },
    d: "M 0.164062 11.703125 C 0.175781 11.71875 0.132812 11.730469 0.109375 11.730469 C 0.0898438 11.734375 0.0898438 11.6875 0.0898438 11.667969 C 0.117188 11.652344 0.136719 11.664062 0.164062 11.703125 Z M 0.164062 11.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078432%,72.941178%,34.117648%)",
      fillOpacity: 1
    },
    d: "M 0.0898438 15.042969 C 0.117188 15.027344 0.140625 15.035156 0.171875 15.066406 C 0.167969 15.089844 0.152344 15.097656 0.113281 15.109375 C 0.0898438 15.109375 0.0898438 15.066406 0.0898438 15.042969 Z M 0.0898438 15.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,16.470589%,64.705884%)",
      fillOpacity: 1
    },
    d: "M 19.011719 11.707031 C 19.019531 11.71875 18.976562 11.726562 18.957031 11.722656 C 18.957031 11.710938 18.980469 11.703125 19.011719 11.707031 Z M 19.011719 11.707031 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmd);
export default __webpack_public_path__ + "static/media/amd.e0e4056462fe764e586578ff4ccd6823.svg";
export { ForwardRef as ReactComponent };